import React, { PropsWithChildren } from 'react';
import { theme } from 'styles';

function ModuleManageList({ children }: PropsWithChildren) {
  return (
    <ul css={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {React.Children.count(children) ? (
        children
      ) : (
        <li
          css={{
            padding: '24px 0',
            textAlign: 'center',
            fontSize: 13,
            color: theme.color.textMuted,
          }}
        >
          오른쪽에서 블록을 추가해주세요
        </li>
      )}
    </ul>
  );
}

export default ModuleManageList;
